"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = EADebugPanel;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
var _mainPanelStyle = require("../style/mainPanelStyle");
var _MainViewTableRow = _interopRequireDefault(require("../fragments/MainViewTableRow"));
var _EAPropTypes = _interopRequireDefault(require("../style/props/EAPropTypes"));
var _openPopoutPanel = _interopRequireDefault(require("../utils/openPopoutPanel"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var WeSDKVersion = _styledComponents["default"].p.withConfig({
  displayName: "MainView__WeSDKVersion",
  componentId: "sc-1dgl433-0"
})(["font-weight:bold;text-align:left;"]);
var title = 'EkoAnalytics Debugger';
function EADebugPanel(_ref) {
  var _ref$trackRecords = _ref.trackRecords,
    trackRecords = _ref$trackRecords === void 0 ? [] : _ref$trackRecords,
    clearTrackRecords = _ref.clearTrackRecords,
    weSdkVersion = _ref.weSdkVersion,
    relevantFieldsConfig = _ref.relevantFieldsConfig,
    setShowConfigureView = _ref.setShowConfigureView,
    setTrackRecordToView = _ref.setTrackRecordToView,
    panelCollapsed = _ref.panelCollapsed,
    setPanelCollapsed = _ref.setPanelCollapsed,
    panelActive = _ref.panelActive,
    setPanelActive = _ref.setPanelActive,
    setStyle = _ref.setStyle;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
    id: "configure-ekoanalytics-debug",
    onClick: function onClick() {
      var isActive = !panelActive;
      setPanelActive(isActive);
      setStyle(function (previousStyle) {
        return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, previousStyle), {}, {
          currentStyle: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, previousStyle.currentStyle), {}, {
            pointerEvents: isActive ? 'auto' : 'none',
            opacity: isActive ? 1 : 0.5
          })
        });
      });
    },
    style: {
      pointerEvents: 'auto'
    }
  }, panelActive ? 'Inactivate' : 'Activate'), /*#__PURE__*/_react["default"].createElement("button", {
    id: "collapse-ekoanalytics-debug",
    onClick: function onClick() {
      var isCollapsed = !panelCollapsed;
      setPanelCollapsed(isCollapsed);
      setStyle(function (previousStyle) {
        return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, previousStyle), {}, {
          currentStyle: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, previousStyle.currentStyle), {}, {
            height: isCollapsed ? _mainPanelStyle.COLLAPSED_HEIGHT : _mainPanelStyle.REGULAR_HEIGHT
          })
        });
      });
    }
  }, panelCollapsed ? 'Expand' : 'Collapse'), /*#__PURE__*/_react["default"].createElement("button", {
    id: "configure-ekoanalytics-debug",
    onClick: function onClick() {
      return setShowConfigureView(true);
    }
  }, "Configure"), /*#__PURE__*/_react["default"].createElement("button", {
    style: {
      "float": 'right'
    },
    id: "clear-ekoanalytics-debug",
    onClick: function onClick() {
      return clearTrackRecords();
    }
  }, "Clear"), /*#__PURE__*/_react["default"].createElement("button", {
    style: {
      "float": 'right'
    },
    id: "popout-ekoanalytics-debug",
    onClick: function onClick() {
      return (0, _openPopoutPanel["default"])();
    }
  }, "Popout"), /*#__PURE__*/_react["default"].createElement(WeSDKVersion, null, "we-sdk: ".concat(weSdkVersion)), /*#__PURE__*/_react["default"].createElement("h2", {
    style: {
      textAlign: 'center'
    }
  }, title), /*#__PURE__*/_react["default"].createElement("h3", null, "Track Calls:"), /*#__PURE__*/_react["default"].createElement("table", {
    style: {
      width: '100%',
      borderCollapse: 'collapse'
    }
  }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", null, "Timestamp"), /*#__PURE__*/_react["default"].createElement("th", null, "Event"), /*#__PURE__*/_react["default"].createElement("th", null, "Relevant Fields"))), /*#__PURE__*/_react["default"].createElement("tbody", null, trackRecords.map(function (trackRecord, index) {
    var onClick = function onClick() {
      return setTrackRecordToView(trackRecord);
    };
    return /*#__PURE__*/_react["default"].createElement(_MainViewTableRow["default"], {
      key: "track-record-".concat(index, "-").concat(trackRecord.eventName),
      trackRecord: trackRecord,
      onClick: onClick,
      relevantFieldsConfig: relevantFieldsConfig
    });
  }))));
}